// @ts-nocheck
import { get } from "@insite/client-framework/Services/ApiService";
import { CustomerDocumentCollectionModel } from "@store/Framework/Types/Documents";

const apiUrl = "/api/v1/custom";

export interface GetCustomerDocumentsApiParameter {}

export const getCustomerDocuments = (parameter?: GetCustomerDocumentsApiParameter) => {
    return get<CustomerDocumentCollectionModel>(`${apiUrl}/customerDocuments`, parameter);
};
